import { render, staticRenderFns } from "./MobileDownloadFixedFooter.vue?vue&type=template&id=680e8388&"
import script from "./MobileDownloadFixedFooter.vue?vue&type=script&lang=ts&"
export * from "./MobileDownloadFixedFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports